import React from 'react';
import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { IconCtaLeftAligned } from '@ahc-digital/component-library';
import { CreateIconCTALeftAlignedModel } from './C33IconCTALeftAligned.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import {
  RenderingProps,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
} from 'src/shared/shared.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C33IconCTALeftAlignedProps = RenderingProps<
  C33IconCTALeftAlignedFields,
  {
    TitleType?: string;
    TitleAlignment?: string;
    SupportCopyAlignment?: string;
    NumberOfColumns?: string;
  } & DynamicPlaceholderParams &
    TranslationOptionsParams &
    AnchorTargetParams
>;

export type C33IconCTALeftAlignedFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  BottomSupportCopy?: RichTextField;
};

export const Default = (props?: C33IconCTALeftAlignedProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }

  return (
    <IconCtaLeftAligned
      {...CreateIconCTALeftAlignedModel(props)}
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
    />
  );
};
